import "./PaymentInfo.scss";

interface PaymentInfoProps {
  supTotal: number;
  discountAmount: number;
  fees: number;
  finalTotal: number;
  totalLoyaltyPtsConsomed?: number;
}

const PaymentInfo: React.FC<PaymentInfoProps> = ({
  supTotal,
  discountAmount,
  fees,
  finalTotal,
  totalLoyaltyPtsConsomed,
}) => {
  return (
    <div className="payment-info">

      <div className="sous-total">
        <p className="label">Sous-total</p>
        <p className="value">{supTotal.toFixed(2)} €</p>
      </div>

      <div className="remise">
        <p className="label">Remise</p>
        <p className="value">
          {discountAmount > 0 && "-"} {discountAmount.toFixed(2)} €
        </p>
      </div>

      <div className="frais">
        <p className="label">Frais</p>
        <p className="value">{fees.toFixed(2)} €</p>
      </div>

      <div className="container-total">
        <div className="total">
          <p className="total-label">Total</p>
          <p className="total-value">{finalTotal.toFixed(2)} €</p>
        </div>


        {totalLoyaltyPtsConsomed != null && (
          <div className="total">
            <p className="total-label"> Points FID </p>
            <p className="total-value">
              {totalLoyaltyPtsConsomed > 0 && "-"}{" "}
              {totalLoyaltyPtsConsomed?.toFixed(2)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentInfo;
